export default __webpack_public_path__ + "static/media/icon-pause.356418a9.svg";